// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 19:40:58

export default {
  "id": "kitty-couple-lovely-valentine",
  "slug": "kitty-couple-lovely-valentine",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/aadb712f85004122969606329c72e234-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/aadb712f85004122969606329c72e234/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Kitty Couple Lovely Valentine",
      "description": "Celebrate love with the adorable kitty duo Angela and Tom in Kitty Couple Lovely Valentine. This charming game takes players on a delightful journey filled with fashion, hidden surprises, and puzzles. Help the cute couple prepare for their special Valentine’s Day by dressing them up, uncovering hidden hearts, and completing their couple photo puzzle.",
      "instructions": "Left Mouse Button Click",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "couple",
        "cutedressup",
        "girls",
        "love",
        "valentine"
      ]
    },
    "zh-CN": {
      "title": "猫咪情侣浪漫情人节",
      "description": "与可爱的小猫情侣安吉拉和汤姆一起庆祝爱情，在《猫咪情侣浪漫情人节》游戏中。这款迷人的游戏带领玩家踏上一段充满时尚、隐藏惊喜和谜题的愉快旅程。帮助这对可爱的小情侣为他们的特别情人节做准备，为他们打扮，揭开隐藏的心形图案，并完成他们的情侣拼图。",
      "instructions": "左鼠标按钮点击",
      "genres": [
        "装扮"
      ],
      "tags": [
        "情侣",
        "可爱装扮",
        "女孩",
        "爱情",
        "情人节"
      ]
    },
    "zh-TW": {
      "title": "貓咪情侶甜蜜情人節",
      "description": "與可愛的貓咪情侶安吉拉和湯姆一起慶祝愛情，在《貓咪情侶可愛情人節》中。這款迷人的遊戲帶領玩家進入一場充滿時尚、隱藏驚喜和謎題的愉快旅程。幫助這對可愛的情侶準備他們特別的情人節，為他們打扮、發現隱藏的心形並完成他們的情人照片謎題。",
      "instructions": "左鍵按鈕點擊",
      "genres": [
        "裝扮"
      ],
      "tags": [
        "情侶",
        "可愛裝扮",
        "女孩",
        "愛情",
        "情人節"
      ]
    },
    "zh-HK": {
      "title": "貓咪情侶可愛情人節",
      "description": "與可愛的貓貓情侶安吉拉和湯姆一起慶祝愛情，在《貓貓情侶可愛情人節》中，這款迷人的遊戲帶玩家進入充滿時尚、隱藏驚喜和謎題的愉悅旅程。幫助這對可愛的情侶準備他們特別的情人節，為他們打扮、發現隱藏的心形圖案，並完成他們的情人照片謎題。",
      "instructions": "左鍵按鈕點擊",
      "genres": [
        "裝飾服裝"
      ],
      "tags": [
        "情侶",
        "可愛裝飾",
        "女孩",
        "愛情",
        "情人節"
      ]
    },
    "ja": {
      "title": "キティカップル ラブリーヴァレンティン",
      "description": "Kitty Couple Lovely Valentineで、可愛いカチュウのコンビアンゲラとトムと一緒に愛を祝おう。この魅力的なゲームは、ファッション、隠されたサプライズ、パズルで満ちた楽しい旅を提供します。カップルをドレスアップし、隠されたハートを見つけ、彼らのカップル写真パズルを解くことで、特別なバレンタインデーの準備を手伝ってください。",
      "instructions": "左マウスボタンクリック",
      "genres": [
        "ドレスアップ"
      ],
      "tags": [
        "カップル",
        "可愛いドレスアップ",
        "ガールズ",
        "愛",
        "バレンタイン"
      ]
    },
    "ko": {
      "title": "키티 커플 로맨틱 밸런타인",
      "description": "좋아하는 사람과 함께 Angel과 Tom의 귀여운猫咪 듀오와 Kitty Couple Lovely Valentine에서 사랑을 축하해보세요. 이 멋진 게임은 패션, 숨겨진 놀라움, 그리고 패러다임을 통해 즐거운 여정을 이어갑니다. 귀여운 커플이 특별한 러브데이를 준비하도록 도와주세요. 그들에게 옷을 입히고 숨겨진 하트를 발견하며 커플 사진 패러다임을 완성하세요.",
      "instructions": "왼쪽 마우스 버튼 클릭",
      "genres": [
        "의상차림"
      ],
      "tags": [
        "커플",
        "귀여운 의상 레이아웃",
        "소녀들",
        "사랑",
        "밸런타인"
      ]
    },
    "fr": {
      "title": "Couple Aimé Kitty pour la Saint-Valentin",
      "description": "Félicitez l'amour avec le adorable duo de chats Angela et Tom dans Kitty Couple Lovely Valentine. Ce charmant jeu emmène les joueurs dans un voyage delightful rempli de mode, de surprises cachées et de puzzles. Aidez le couple adorable à se préparer pour leur jour de Saint-Valentin en les habillant, en découvrant des cœurs cachés et en complétant leur puzzle photo de couple.",
      "instructions": "Clic gauche de la souris",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "cuple",
        "déguisement mignon",
        "filles",
        "amour",
        "Saint-Valentin"
      ]
    }
  }
};
